import { Link } from "react-router-dom";
import type { Article } from "@/types/melon";
import { getTopicTone, topicChipTone } from "@/utils/tone";

type RelatedArticlesProps = {
  items: Article[];
};

export default function RelatedArticles({ items }: RelatedArticlesProps) {
  if (items.length === 0) return null;

  return (
    <section className="mt-14 border-t border-background-200 pt-10">
      <div className="flex items-end justify-between gap-4">
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">相关推荐</h2>
        <Link
          to="/topics"
          className="whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-600"
        >
          更多整理稿
          <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>
      <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-3">
        {items.map((item) => {
          const tone = getTopicTone(item.topicSlug);
          return (
            <Link
              key={item.slug}
              to={`/article/${item.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className={`self-start rounded-full border px-2 py-0.5 text-[11px] ${topicChipTone[tone]}`}>
                {item.topicName}
              </span>
              <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                {item.title}
              </h3>
              <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
              <span className="mt-4 text-xs text-foreground-500">{item.readTime} · 热度 {item.heat}</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}